import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { FloatingBar } from 'ziphy-web-shared/basic/lib/simple';
import { $layouts } from 'ziphy-web-shared/basic/utils/layouts';
import { $notes } from '../../Notes.store';
import SignButton from '../signButton/SignButton';
import UnlockButton from '../unlockButton/UnlockButton';
import styles from './FloatBar.module.scss';
const FloatBar = () => {
    const { t } = useTranslation();
    const floatBarRef = useRef(null);
    const { ref: inViewRef, inView } = useInView({ initialInView: true });
    const isOkEncounter = $notes.encounterStatus.isStarted && !$notes.encounterStatus.isCancelled;
    const hasValidateErrors = $notes.beforeSignErrors.size || $notes.validateErrors.length;
    const isSignNeeded = $notes.isChanged;
    if (!isOkEncounter) {
        return _jsx(_Fragment, {});
    }
    const isEnabled = $notes.isSigned ||
        ($notes.isLocked && isOkEncounter) ||
        // (!$notes.isLocked && !hasValidateErrors)
        !$notes.isLocked;
    const calculateBottomOffset = () => {
        var _a;
        if (inView && !$notes.isLocked && ($notes.isEditable || $notes.isSigned)) {
            return -(30 + ((_a = floatBarRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight));
        }
        return $layouts.marginBottom || 0;
    };
    if (!isEnabled) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", Object.assign({ ref: inViewRef, id: "notes-locked-bar" }, { children: _jsx(FloatingBar, Object.assign({ ref: floatBarRef, label: isSignNeeded
                ? t('label.unsigned_changes_available')
                : $notes.isLocked
                    ? t('label.notes_locked')
                    : t('label.notes_unlocked'), bottomOffset: calculateBottomOffset() }, { children: _jsxs("div", Object.assign({ className: styles.buttons }, { children: [isSignNeeded && _jsx(SignButton, { buttonMode: ['primary', 'sm'] }), _jsx(UnlockButton, {})] })) })) })));
};
export default observer(FloatBar);
